import { collection, doc, getFirestore, limit, onSnapshot, orderBy, query, writeBatch } from 'firebase/firestore';
import { useEffect, useMemo, useState } from 'react';
import { useAuth } from './useAuth';

type TUsePrimaryNotification = {
  notifications: any[];
  unreadNotificationsCount: number;
  markNotificationsAs: (notis: any[], isViewed: boolean) => Promise<void>;
  isLoaded: boolean;
};

export const usePrimaryNotification = (): TUsePrimaryNotification => {
  const { user } = useAuth();
  const db = getFirestore();
  const [notifications, setNotifications] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (user && user?.id) {
      const colRef = collection(db, `notifications/${user?.id}/messages`);
      const q = query(colRef, orderBy('createdAt', 'desc'), limit(30));
      const unsubscribe = onSnapshot(q, (snapShot) => {
        const m: any = [];
        snapShot.docs.forEach((docElm) => {
          if (docElm.data()) {
            if (docElm.data().type !== 'referrals') {
              m.push({ ...docElm.data(), id: docElm.id });
            }
          }
        });
        setNotifications(m);
        if (!isLoaded) setIsLoaded(true);
      });

      return unsubscribe;
    }

    return undefined;
  }, [user]);

  const markNotificationsAs = async (notis: any[], isViewed: boolean) => {
    const batch = writeBatch(db);
    notis.forEach((d: any) => {
      const notificationRef = doc(db, `notifications/${user?.id}/messages`, d.id);
      batch.update(notificationRef, { isViewed });
    });
    await batch.commit();
  };

  const unreadNotificationsCount = useMemo(
    () =>
      notifications.reduce((prevVal, n: any) => {
        if (!n.isViewed) return prevVal + 1;
        return prevVal;
      }, 0),
    [notifications],
  );

  return {
    notifications,
    unreadNotificationsCount,
    markNotificationsAs,
    isLoaded,
  };
};
